import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { AutorizacionService } from '../../services/autorizacion.service';

import { AutenticacionService } from '../../../shared/services/autenticacion.service';
import { AutorizacionSolicitud } from '../../../shared/models/autorizacion-solicitud';
import { ConsultaSolicitud } from '../../../shared/models/consulta-solicitud';
import { Constantes } from '../../../shared/constantes';

import { AlertaService } from '../../../shared/components/alerta/alerta.service';
import { SpinnerService } from '../../../shared/components/spinner/spinner.service';

declare var $: any;

@Component({
  selector: 'app-autorizacion',
  templateUrl: './autorizacion.component.html',
  styleUrls: ['./autorizacion.component.css']
})
export class AutorizacionComponent implements OnInit {
  @ViewChild('modal') modal: ElementRef;
  mostrarAutorizacion: boolean = false;
  mensajeAutorizacion: string = '';
  redirigirDetalle: boolean = false;
  autorizacion: AutorizacionSolicitud;

  constructor(private translate: TranslateService,
    private autenticacionService: AutenticacionService,
    private autorizacionService: AutorizacionService,
    private alertaService: AlertaService,
    private spinnerService: SpinnerService,
    private router: Router,
    private activateRoute: ActivatedRoute) { }

  ngOnInit() {
    //obtiene el codigo desde la url
    this.activateRoute.params
      .subscribe(
      (params: Params) => {
        var codigo = String(params['codigo']);
        this.validarCodigoParaAutorizacion(codigo);
      }
      );
  }

  validarCodigoParaAutorizacion(codigo: string) {
    this.spinnerService.show();

    this.autorizacionService.validarCodigoParaAutorizacion(codigo)
      .subscribe(
      (data) => {
        if (data.codigoRespuesta === Constantes.CODIGO_RESPUESTA_OK) {
          this.mostrarAutorizacion = true;

          this.mensajeAutorizacion = data.mensaje;
          this.autorizacion = data.object;

          this.spinnerService.hide();
        } else {
          this.mostrarAutorizacion = false;

          this.alertaService.warning_noclose(data.mensaje);
        }
      },
      (error) => { this.alertaService.error('Error al consultar la solicitud por codigo de autorización, por favor intente mas tarde.'); }
      );
  }

  autorizar() {
    this.procesarAutorizacion(true);
  }

  rechazar() {
    $(this.modal.nativeElement).modal('show');
  }

  confirmarRechazar() {
    $(this.modal.nativeElement).modal('hide');
    this.procesarAutorizacion(false);
  }

  procesarAutorizacion(respuesta: boolean) {
    this.spinnerService.show();

    this.autorizacionService.procesarAutorizacion(this.autorizacion.idSolicitud, respuesta)
      .subscribe(
      (data) => {
        if (data.codigoRespuesta === Constantes.CODIGO_RESPUESTA_OK) {
          //true:AUTORIZADO - false:RECHAZADO
          if (data.object) {
            if (this.autorizacion.esSolicitante) {
              var consultaSolicitud: ConsultaSolicitud = <ConsultaSolicitud>{};
              consultaSolicitud.numeroSolicitud = this.autorizacion.idSolicitud;
              consultaSolicitud.tipoIdentificacion = this.autorizacion.tipoDocumentoSolicitud;
              consultaSolicitud.numeroIdentificacion = this.autorizacion.numeroDocumentoSolicitud;

              this.autenticacionService.login(consultaSolicitud)
                .subscribe(
                (data) => {
                  if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
                    //redirecciona al detalle
                    this.router.navigate(['/detalle', this.autorizacion.idSolicitud], { queryParams: { q: 'N' } });
                  } else {
                    this.alertaService.warning(data.mensaje);
                  }
                },
                (error) => { this.alertaService.error('Error al generar el token de seguridad, por favor intente mas tarde.') }
                );
            } else {
              this.mostrarAutorizacion = false;
            }
          } else {
            this.mostrarAutorizacion = false;
          }

          this.alertaService.success_noclose(data.mensaje);
        } else {
          this.alertaService.warning_noclose(data.mensaje);
        }
      },
      (error) => { this.alertaService.error('Error al consultar la solicitud por codigo de autorización, por favor intente mas tarde.') }
      );
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/components/autorizacion/autorizacion.component.ts